import { Command } from '@/app/tracking/api';

interface QuestionAttempt {
  id: string
  attempts: {
    thinkingTimeSeconds: number
    achievedScore: number
  }[]
}

export type AddQuestionAttemptsTrackingCommandPayload = QuestionAttempt[]

export const AddQuestionAttemptsTrackingCommandName = 'add-question-attempts' as const;
export type AddQuestionAttemptsTrackingCommand =
      Command<typeof AddQuestionAttemptsTrackingCommandName, AddQuestionAttemptsTrackingCommandPayload>;
